import { switchMap, catchError, of, firstValueFrom } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { validateReCaptcha } from 'constants/routes';

function validateReCaptchaToken(token) {
  const observable$ = fromFetch(validateReCaptcha, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify({ ReCaptchaToken: token }),
  }).pipe(
    switchMap((response) => response.json()),
    catchError(() => of({ Success: true }))
  );

  return firstValueFrom(observable$);
}

export default validateReCaptchaToken;